__turbopack_context__.v({
  "active": "studio-module__WDWx4G__active",
  "addSceneButton": "studio-module__WDWx4G__addSceneButton",
  "addSceneCard": "studio-module__WDWx4G__addSceneCard",
  "addSceneCardPlus": "studio-module__WDWx4G__addSceneCardPlus",
  "addSceneIcon": "studio-module__WDWx4G__addSceneIcon",
  "alertInputWrapper": "studio-module__WDWx4G__alertInputWrapper",
  "cancelButton": "studio-module__WDWx4G__cancelButton",
  "card": "studio-module__WDWx4G__card",
  "containerGeneral": "studio-module__WDWx4G__containerGeneral",
  "containerLoader": "studio-module__WDWx4G__containerLoader",
  "containerStudioScenes": "studio-module__WDWx4G__containerStudioScenes",
  "deleteButton": "studio-module__WDWx4G__deleteButton",
  "deleteButtonsWrapper": "studio-module__WDWx4G__deleteButtonsWrapper",
  "editTxtBtn": "studio-module__WDWx4G__editTxtBtn",
  "emptyHint": "studio-module__WDWx4G__emptyHint",
  "emptyWrapper": "studio-module__WDWx4G__emptyWrapper",
  "fontBold": "studio-module__WDWx4G__fontBold",
  "heading": "studio-module__WDWx4G__heading",
  "headingWrapper": "studio-module__WDWx4G__headingWrapper",
  "hidden": "studio-module__WDWx4G__hidden",
  "input": "studio-module__WDWx4G__input",
  "listGrid": "studio-module__WDWx4G__listGrid",
  "loadingRoot": "studio-module__WDWx4G__loadingRoot",
  "loadingText": "studio-module__WDWx4G__loadingText",
  "percentage": "studio-module__WDWx4G__percentage",
  "plusWrapper": "studio-module__WDWx4G__plusWrapper",
  "progress": "studio-module__WDWx4G__progress",
  "sceneSearch": "studio-module__WDWx4G__sceneSearch",
  "sceneTypeSwitcher": "studio-module__WDWx4G__sceneTypeSwitcher",
  "sortAndSearch": "studio-module__WDWx4G__sortAndSearch",
  "sortScene": "studio-module__WDWx4G__sortScene",
  "spin": "studio-module__WDWx4G__spin",
});
